import { Component, forwardRef } from "react";
import { useNavigationItem } from "../hooks/useNavigationItem";
import useUserStoreV2 from "store/user-store-v2/useUserStoreV2";

const withAppSideBarLogout = (Component: React.ComponentType<any>) => {
  return forwardRef(
    (
      {
        children,
        ...props
      }: {
        children: React.ReactNode;
      },
      ref,
    ) => {
      const { tgUserName, logoutTgUserV2, checkIsFromMiniApp } = useUserStoreV2();
      const isFromMiniApp = checkIsFromMiniApp();

      const onClickLogout = async () => {
        logoutTgUserV2();
      };

      return !isFromMiniApp && tgUserName ? (
        <Component ref={ref} onClick={onClickLogout} {...props}>
          {children}
        </Component>
      ) : null;
    },
  );
};

export default withAppSideBarLogout;
